import { AlertCircle, AlertTriangle } from '@tamagui/lucide-icons';
import { InstrumentValidationError } from '@unistocks/features/external-accounts/models/instrument-validation-error';

export const renderValidationIcon = (validation: InstrumentValidationError | null) => {
  if (!validation) return null;

  const Icon = validation === 'Error' ? AlertCircle : AlertTriangle;

  return <Icon size={'$2'} color={validation === 'Error' ? '$danger' : '$warning'} />;
};
